'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEX_CODE_REGEX = new RegExp('^#?([a-fA-F\\d]{2})([a-fA-F\\d]{2})([a-fA-F\\d]{2})$');

exports.default = HEX_CODE_REGEX;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PatternValidationJS/static-1.38/js/regex/HexCodeRegex.js
// module id = 221
// module chunks = 0 1